// src/pages/Dashboard.js
import React, { useEffect } from 'react';
//import '../styles/styles.css';
import logo from '../assets/img/logo.png';
import avatar from '../assets/img/user_avatar.jpeg';
import Header from '../components/Header';
import flatpickr from 'flatpickr';

const Orders = () => {
  useEffect(() => {
    setTimeout(() => {
      flatpickr('#datePicker', { dateFormat: 'Y-m-d' });
    }, 0);
  }, []);

  return (
    <>
      {/* Header */}
      <Header />

      {/* Dashboard Content */}
      <main className="dashboard">
        <section className="statistics-row">
          <div className="left-content">
            <h2>Orders Page</h2>
          </div>
          <div className="right-content">
            <div className="date-picker-container">
              <input type="text" id="datePicker" placeholder="Pick a date" />
            </div>
          </div>
        </section>


      </main>

      {/* Footer */}
      <footer>
        <div className="container">
          <p>&copy; 2025 Tensor Planet. All rights reserved.</p>
        </div>
      </footer>
    </>
  );
};

export default Orders;
